<template>
  <div>
    <button @click="handleLogout" v-if="loggedUser">Log out</button>
    <div class="about" v-if="!loggedUser">
        <form>
          <label for="email">email:</label>
          <input type="email" name="email" v-model="emailLogin">
          <label for="password">password:</label>
          <input type="password" name="password" v-model="passwordLogin">
          <button @click="handleLogin">Log in</button>
        </form>
        
    </div>
  </div>  
</template>

<script>
  import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from '@firebase/auth'
import { ref } from 'vue'
  import { auth } from '../main'
  export default{
    setup(props, context){
      const email = ref('')
      const password = ref('')
      const emailLogin = ref('')
      const passwordLogin = ref('')
      const loggedUser = ref(false)
      const showSignUpForm = ref(false)

      const handleSignUp = (e) => {
        e.preventDefault()
          createUserWithEmailAndPassword(auth, email.value, password.value)
            .then((cred) => {
              email.value = ''
              password.value = ''
            })
            .catch((err) => {
              console.log(err.message)
            })
      }
      const handleLogin = (e) => {
        e.preventDefault()
        signInWithEmailAndPassword(auth, emailLogin.value, passwordLogin.value)
          .then((cred) => {
            emailLogin.value = ''
            passwordLogin.value = ''
          })
          .catch((err) => {
            console.log(err.message)
          })
      }
      const handleLogout = (e) => {
        signOut(auth)
          .then(() => {
            console.log('User log out')
          })
          .catch((err) => {
            console.log(err.message)
          })
      }
      onAuthStateChanged(auth, (user) => {
        if(user){
          loggedUser.value = user.email
        }
        else{
          loggedUser.value = null
        }
        context.emit('log', loggedUser.value)
      })
      return{
        handleSignUp, email, password, handleLogout, handleLogin, emailLogin, passwordLogin, loggedUser, showSignUpForm
      }
    }
  }
</script>

<style>
 input{
        display: block;
        padding: 0.5em;
        margin-bottom: 0.5em;
        margin: 0.5em auto;
        border-radius: 0.5em;
        outline: none;
    }
  .about > p {
    margin-top: 4em;
  }
</style>
